import { FormGroup } from '@angular/forms';
import { IUser } from '@app/models/user.interface';
import { createAction, props } from '@ngrx/store';

export const login = createAction(
  '[Core] log user Action',
  props<any>()
);

export const loginSuccess = createAction(
  '[Core] log user Success Action',
  props<{ locations: any }>()
);

export const loginFail = createAction(
  '[Core] log user Fail Action',
  props<{ error: any }>()
);

export const setIsSideNavOpen = createAction(
  '[Core] is Side Nav Open',
  props<{isSideNavOpen:  boolean }>()
);

export const setIsSideNavCollapsed = createAction(
  '[Core] is Side Nav Collapsed',
  props<{ isSideNavCollapsed: boolean }>()
);

export const loadLocations = createAction(
  '[Core] Load Locations Action',
);

export const loadLocationsSuccess = createAction(
  '[Core] Load Locations Success Action',
  props<{ locations: any }>()
);

export const loadLocationsFailure = createAction(
  '[Core] Load Locations Failure Action',
  props<{ error: any }>()
);

export const loadMe = createAction(
  '[Core] Load Me'
)

export const resetMe = createAction(
  '[Core] Reset Me'
);

export const loadMeSuccess = createAction(
  '[Core] Load Me Success',
  props<{ user: IUser }>()
)

export const loadMeFailure = createAction(
  '[Core] Load Me Failure',
  props<{ error: object }>()
)

export const updateMe = createAction(
  '[Core] Update Me',
  props<{ form: FormGroup }>()
)

export const updateMeSuccess = createAction(
  '[Core] Update Me Success',
  props<{ user: IUser }>()
)

export const updateMeFailure = createAction(
  '[Core] Update Me Failure',
  props<{ error: object }>()
)

export const setTitle = createAction(
  '[Core] Set Title',
  props<{ title: string }>()
)

export const increaseCurrentLimit = createAction(
  '[Core] Increase Current Limit',
  props<{ types: string, increase_count?: number }>()
)

export const decreaseCurrentLimit = createAction(
  '[Core] Decrease Current Limit',
  props<{ types: string, decrease_count?: number }>()
)

export const showErrorMessage = createAction(
  '[Error] Show Error Message',
  props<{ title: string, body: string, show_upgrade:boolean }>()
)

export const showPermissionMessage = createAction(
  '[Error] Show Permission Message',
  props<{ title: string, body: string }>()
)


export const updateLocation = createAction(
  '[Core] Update Location Form',
  props<{ form: FormGroup, id: number }>()
)

export const updateLocationSuccess = createAction(
  '[Core] Update Location Form Success',
  props<{ location: any }>()
)

export const updateLocationFailure = createAction(
  '[Core] Update Location Form Failure',
  props<{ error: any }>()
)

export const changePassword = createAction(
  '[Core] Change Password',
  props<{ form: FormGroup }>()
)

export const changePasswordSuccess = createAction(
  '[Core] Change Password Success',
  props<{ user: IUser }>()
)

export const changePasswordFailure = createAction(
  '[Core] Change Password Failure',
  props<{ error: object }>()
)

